<template>
    <div :class="[
        'coupon-empty bg-color-secondary',
        { 'flex': isFlex }
    ]">
        <div class="coupon-empty-body text-center">
            <header class="fs-40 fs-lh-60">
                Dziękujemy za aktualizację danych!
            </header>
            <span class="fs-32 fs-lh-60 text-bold">
                Zapraszamy na zakupy do MAKRO
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isFlex: {
            type: Boolean,
            required: false,
            default: false
        }
    }
}
</script>

<style lang="scss">
.coupon-empty {
    padding: 4px 0 0;
    margin-top: 24px;

    &-body {
        padding: 50px 15px;
    }

    @media (max-width: $screen-mobile-landscape) {
        &-body {
            .fs-40 {
                font-size: 3.0rem;
                line-height: 3.0rem;
                margin-bottom: 20px;
            }

            .fs-32 {
                font-size: 2.4rem;
                line-height: 2.7rem;
            }
        }
    }
}
</style>
